import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import Switch from '@xcritical/switch';

import {
  dashboardActions,
  PageMode,
  useDashboard,
} from '@crm-framework/dashboard';

import { WrapperItem } from '../styles';

export interface IDashboardModeCheckboxProps {
  dashboardName: string;
}

export const DashboardModeCheckbox: React.FC<IDashboardModeCheckboxProps> = ({
  dashboardName,
}) => {
  const dispatch = useDispatch();

  const {
    settings: { infinityScrollModeEnable, pageMode },
    isLoading,
  } = useDashboard(dashboardName);

  const onChange = useCallback((_checked: boolean) => {
    dispatch(
      dashboardActions.changeSettings(dashboardName, {
        key: 'pageMode',
        value: _checked ? PageMode.infinite : PageMode.pages,
      })
    );
  }, []);

  if (!infinityScrollModeEnable) return null;

  return (
    <WrapperItem>
      <Switch
        name="InfinityScroll"
        label="Fast mode"
        disabled={isLoading}
        onChange={onChange}
        checked={pageMode === PageMode.infinite}
      />
    </WrapperItem>
  );
};
